import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field, reduxForm } from 'redux-form';

import Typography from '@material-ui/core/Typography';
import HelpIcon from '@material-ui/icons/Help';

import {
  DEFAULT_LANGUAGE,
  AVAILABLE_LANGUAGES
} from 'pages/create-activity/constants';

import {
  ChipsInput,
  FormActionButtons,
  Input,
  MultipleSelectField,
  PopoverWrapper
} from 'components';
import { TRANSLATIONS } from 'translations/index';

import validate from './validateSecondLanguage';

import { useStyles } from 'components/general-create/styles';

const AccommodationGeneralCreateSecondLanguage = ({
  save,
  onSubmit,
  handleSubmit,
  setSubmitButton,
  isUpdate,
  ...otherProps
}) => {
  const {
    languages,
    selectedLanguage,
    addLanguage,
    deleteLanguage,
    selectLanguage
  } = otherProps;
  const [t] = useTranslation();

  const classes = useStyles();
  const availableLanguages = [...AVAILABLE_LANGUAGES].filter(
    x => !languages.includes(x)
  );

  return (
    <div className={classes.wrapper}>
      <Typography variant="h1" className={classes.title}>
        {t('General')}
      </Typography>
      <MultipleSelectField
        availableItems={availableLanguages}
        notAvailableToDeleteItems={[DEFAULT_LANGUAGE]}
        list={languages}
        selectedItem={selectedLanguage}
        addItem={addLanguage}
        deleteItem={deleteLanguage}
        selectItem={selectLanguage}
      />
      <form onSubmit={handleSubmit}>
        <Field
          name={`title`}
          inputProps={{ maxLength: 255 }}
          label={`${TRANSLATIONS[selectedLanguage].title} *`}
          placeholder={`${TRANSLATIONS[selectedLanguage].title}`}
          className={classes.inputIndent}
          component={Input}
        />
        <Field
          name="bedDetails"
          id="bedDetails"
          className={classes.inputIndent}
          label={
            <div className={classes.labelWithHelpIcon}>
              <span>{TRANSLATIONS[selectedLanguage].bedDetails}</span>
              <PopoverWrapper
                text={`${TRANSLATIONS[selectedLanguage].includedHelpMessage}`}
              >
                <HelpIcon className={classes.chipsHelpIcon} />
              </PopoverWrapper>
            </div>
          }
          placeholder={`Trykk Enter for å legge til et element`}
          maxLength="255"
          component={ChipsInput}
        />
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

export default reduxForm({
  form: `generalForm`,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  validate
})(AccommodationGeneralCreateSecondLanguage);
